export default __webpack_public_path__ + "static/media/YoutubeDl.9b5ee27b.png";